import React from "react"
import { HiBookOpen } from "react-icons/hi2"
import { IoHandLeftSharp } from "react-icons/io5"
import { useNavigate } from "react-router-dom"

import { logoText } from "@fuse/sharedComponents/legacyUI/Top/styles"
import { ROUTES } from "src/App"

import {
  TDeviceType,
  useDeviceTypeByWidth,
} from "@fuse/customHooks/useDeviceTypeByWidth"

import { GenericFeedbackCommon } from "../GenericFeedback"

export interface IFooter {
  className?: string
  isEventDetailFooter?: boolean
  isAdmin?: boolean
}

const Footer: React.FC<IFooter> = ({
  className = "",
  isEventDetailFooter = false,
  isAdmin = false,
}) => {
  const deviceType = useDeviceTypeByWidth()
  const navigate = useNavigate()

  const isMobile = deviceType === TDeviceType.MOBILE

  const handleButtonClick = (url: string) => {
    window.open(url, "_blank")
  }

  const onCreateEvent = () => {
    navigate(ROUTES.CREATE_EVENT_V5)
  }

  if (isEventDetailFooter && isMobile) {
    return (
      <div className="bg-white/10 border-white/20 border p-4 rounded-2xl sm:bg-transparent sm:border-0 sm:px-0 sm:py-0 sm:rounded-none mx-5 mb-6 ">
        <div
          className="text-4xl min-w-max font-bold leading-6 drop-shadow-lg flex items-center justify-center mb-8 mt-3"
          style={{ ...logoText, textShadow: "0px 0px 10px white" }}
        >
          <p className="font-syne">
            let's
            <br />
            <span className="mt-2 block">hang</span>
          </p>
        </div>

        <div className="flex flex-col items-start gap-2 my-4">
          <button
            onClick={() =>
              handleButtonClick("https://pages.flycricket.io/walkme/terms.html")
            }
            className="text-left text-base sm:text-sm font-medium bg-transparent flex gap-2 justify-start items-center p-0 w-full"
          >
            <HiBookOpen size={18} fill={"#FFFFFF99"} />
            <div className="text-nowrap text-white/80">TERMS OF SERVICE</div>
          </button>

          <button
            onClick={() =>
              handleButtonClick("https://pages.flycricket.io/walkme/terms.html")
            }
            className="text-left text-base sm:text-sm font-medium bg-transparent flex gap-2 justify-start items-center p-0 w-full"
          >
            <IoHandLeftSharp size={18} fill={"#FFFFFF99"} />
            <div className="text-nowrap text-white/80">PRIVACY POLICY</div>
          </button>
        </div>

        <div
          onClick={() => {
            onCreateEvent()
          }}
          className="w-full flex items-center justify-center text-lg text-white/80 cursor-pointer bg-white/20 py-2 rounded-lg"
        >
          {isAdmin ? "Create another event" : "Create your own event"}
        </div>
      </div>
    )
  } else {
    return (
      <div
        className={`flex flex-col md:flex-row w-full items-start md:items-center justify-center text-white px-8 py-4 sm:px-8 sm:py-4  md:px-16 md:py-6 lg:px-20 lgpy-8 ${className}`}
      >
        <div className="flex py-4 mt-12 md:mt-0 justify-between items-center  w-full  rounded-xl flex-col md:flex-row gap-6 ">
          <div
            className="text-[24px] min-w-max font-bold leading-6 drop-shadow-lg"
            style={{ ...logoText, textShadow: "0px 0px 10px white" }}
          >
            <div className="font-syne">let's hang</div>
          </div>
          <div className="flex gap-4 flex-col sm:flex-row w-full justify-between ">
            <div className={" gap-6 flex flex-col sm:flex-row"}>
              <button
                onClick={() =>
                  handleButtonClick(
                    "https://pages.flycricket.io/walkme/terms.html",
                  )
                }
                className="text-left text-sm font-medium  bg-transparent flex gap-2 item-center justify-center items-center p-0"
              >
                <HiBookOpen size={18} fill={"#FFFFFF99"} />
                <div className="text-nowrap">TERMS OF SERVICE</div>
              </button>

              <button
                onClick={() =>
                  handleButtonClick(
                    "https://pages.flycricket.io/walkme/privacy.html",
                  )
                }
                className="text-left text-sm font-medium hover:opacity-80 bg-transparent flex gap-2 item-center justify-center items-center p-0"
              >
                <IoHandLeftSharp size={18} fill={"#FFFFFF99"} />
                <div className="text-nowrap">PRIVACY POLICY</div>
              </button>
            </div>
            <div className="flex justify-center">
              <GenericFeedbackCommon />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
